import React, { useContext } from "react"
import cal from "clsx"
import Drawer from "@material-ui/core/Drawer"

import { AppContext } from "Views/Home/context"
import SideList from "./SideList"
import SideHeader from "./SideHeader"
import { useSideDrawerStyles } from "./style"
import { useSwitch } from "Hooks/basic"

// 侧边栏抽屉
const SideDrawer = () => {
    const classes = useSideDrawerStyles()
    const { drawerOpen } = useContext(AppContext)
    const { open, handleOpen, handleClose } = useSwitch(false)
    return (
        <Drawer
            variant="permanent"
            classes={{
                paper: cal(
                    classes.drawerPaper,
                    !drawerOpen && classes.drawerPaperClose,
                    open && classes.drawer,
                ),
            }}
            open={drawerOpen}
            onMouseEnter={handleOpen}
            onMouseLeave={handleClose}
        >
            <div className={classes.mask}>
                <SideHeader />
                <SideList />
            </div>
        </Drawer>
    )
}

export default SideDrawer
